import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import FilePresentIcon from '@mui/icons-material/FilePresent';
import MessageIcon from '@mui/icons-material/Message';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import {Box, Button, Link, Stack, Typography} from '@mui/material';
import Grid from '@mui/material/Grid';
import parse from 'html-react-parser';
import * as React from 'react';
import {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import axios from '../../axios';
import {shortDateFormat, truncateStr} from '../Service';
import {useDarkMode} from '../darkMode/hook/useDarkMode';
import LikeButton from '../like/LikeButtonActu';
import Tags from '../tag/Tag';
import ActualityComment from './ActualityComment';
import './actuality.css';
import {useComments} from './hooks/useComments';
import {useLikeCount} from './hooks/useLike';

const ActualityExpandLess = ({
  actuality,
  expandMore,
  handleToggleClick,
  showCommunityInfo,
}) => {
  const [expandeComment, setExpandeComment] = useState(false);
  const {mode} = useDarkMode();

  const handleToggleComment = () => {
    setExpandeComment(!expandeComment);
  };
  const {commentCount} = useComments(actuality.id);
  const {likeCount} = useLikeCount('actuality', actuality.id);
  const navigate = useNavigate();
  return (
    <Stack
      style={{
        backgroundColor: mode.settings.cardBackgroundColor,
      }}
      direction={'row'}
      flexWrap={'wrap'}>
      <Box
        sx={{
          backgroundImage: `url(${axios.defaults.apiBaseURL}/${actuality.image.uri}), url(${process.env.REACT_APP_DEV_HOST}/assets/img/service0.jpg)`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          borderRadius: 1,
          width: {xs: '100%', md: '100%', lg: '350px'},
          height: {xs: '500px', md: '500px', lg: '275px'},
        }}
      />
      <Grid
        item
        xs
        sm
        container
        direction="column"
        spacing={1}
        className={'communityElement'}
        sx={{marginLeft: {xs: 0, md: 0, lg: 5.5}}}>
        <Grid item xs sx={{paddingLeft: '0px !important'}}>
          <Typography
            variant="subtitle1"
            component="div"
            className={'actualityHeaderContainer'}>
            {showCommunityInfo ? (
              <Typography className={'actualityHeaderContainer'}>
                <Typography
                  component={'div'}
                  className={'actualityCommunityName'}
                  style={{color: mode.settings.textColor6}}>
                  {actuality.community.name}
                </Typography>
                <Button
                  className="btn-gradient"
                  variant="contained"
                  size="large"
                  endIcon={
                    <RemoveRedEyeIcon
                      role={'img'}
                      aria-label="Voir le détail de la communauté"
                    />
                  }
                  sx={{width: 75, height: 37, marginRight: 2}}
                  onClick={() =>
                    navigate(`/community/${actuality.community.id}`)
                  }>
                  <Typography variant={'subtitle3'}>Voir</Typography>
                </Button>
              </Typography>
            ) : (
              ''
            )}
            <Tags tags={actuality.tags}/>
          </Typography>

            <Typography
              variant="h3"
              className="communityTitle"
              style={{color: mode.settings.textColor3, marginTop: 5}}>
              {actuality.title.text}
            </Typography>

          <Typography
            component={'div'}
            variant="subtitle1"
            gutterBottom
            className="communityAttributesContainer"
            style={{color: mode.settings.textColor3}}>
            <CalendarMonthIcon
              className="communityIcon"
              role={'img'}
              aria-label="Date de publication de l'actualité"
            />
            <span className="communityAttributes">
              {' '}
              {shortDateFormat(actuality.published_date)}
            </span>
          </Typography>

          <Typography className="communityDescription" variant={'subtitle1'}>
            <span style={{color: mode.settings.textColor3}}>
              {truncateStr(
                actuality.short_description.text
                  .replaceAll(/<[^>]+>/g, '')
                  .replaceAll('&nbsp;', ' '),
                125,
              )}
            </span>
          </Typography>

          <Stack
            variant="subtitle1"
            className="communityButtonContainer"
            component={'div'}
            style={{backgroundColor: mode.settings.card3BackgroundColor}}
            gap={2}
            direction={'row'}
            flexWrap={'wrap'}
            sx={{
              justifyContent: {xs: 'center', md: 'center', lg: 'space-between'},
            }}>
            <Stack
              direction="row"
              justifyContent="left"
              alignItems="center"
              sx={{color: '#3E9FDD', cursor: 'pointer'}}
              onClick={handleToggleClick}>
              <ArrowDropDownIcon
                className="linkArrow"
                aria-label="Voir plus"
                sx={{marginLeft: -0.6}}
              />
              <Typography variant={'subtitle1'}>
                {expandMore ? 'Afficher moins' : "Lire l'article en entier"}
              </Typography>
            </Stack>
            <LikeButton type={'actuality'} contentId={actuality.id} />
          </Stack>
        </Grid>
      </Grid>

      <Typography width={'100%'}>
        {expandeComment ? (
          <ActualityComment actualityId={actuality.id} />
        ) : (
          <></>
        )}
      </Typography>
    </Stack>
  );
};

export default ActualityExpandLess;
